export enum Group {
  escalfem = '1',
  activitat = '2',
  reflexio = '3',
}
